import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * When the Cloud Function redirects browsers from /p/:id or /trip/:id to /?profile=:id or /?trip=:id,
 * we navigate to /p/:id or /trip/:id and replace history so the URL bar shows the share link.
 */
export default function ProfileRedirect({ children }) {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const profileId = searchParams.get('profile');
    if (profileId) {
      navigate(`/p/${profileId}`, { replace: true });
      return;
    }
    const tripId = searchParams.get('trip');
    if (tripId) {
      // Keep the shared itinerary token (/trip/:id?s=token).
      const s = searchParams.get('s');
      navigate(`/trip/${tripId}${s ? `?s=${encodeURIComponent(s)}` : ''}`, { replace: true });
      return;
    }
    const inviteToken = searchParams.get('invite');
    if (inviteToken) {
      navigate(`/i/${inviteToken}`, { replace: true });
    }
  }, [searchParams, navigate]);

  return children;
}
